import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '@/lib/i18n';
import axios from 'axios';
import DOMPurify from 'dompurify';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PAGE_TITLES = {
  'cgv': { fr: 'Conditions Générales de Vente', en: 'Terms & Conditions' },
  'mentions-legales': { fr: 'Mentions Légales', en: 'Legal Notice' },
  'politique-cookies': { fr: 'Politique de Cookies', en: 'Cookie Policy' },
};

export default function LegalPage() {
  const location = useLocation();
  const pageType = location.pathname.replace('/', '');
  const { lang } = useTranslation();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get(`${API_URL}/api/legal/${pageType}`)
      .then(r => setContent(r.data?.content || ''))
      .catch(() => setContent(''))
      .finally(() => setLoading(false));
  }, [pageType]);

  const titles = PAGE_TITLES[pageType] || { fr: pageType, en: pageType };
  const title = lang === 'en' ? titles.en : titles.fr;

  return (
    <div className="bg-[#0A0A0A] min-h-screen pt-24 pb-16" data-testid={`legal-page-${pageType}`}>
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-8">{title}</h1>
        {loading ? (
          <div className="text-slate-400">Chargement...</div>
        ) : content ? (
          <div
            className="prose prose-invert prose-green max-w-none text-slate-300 leading-relaxed
              [&_h1]:text-white [&_h1]:font-heading [&_h1]:text-2xl [&_h1]:mt-8 [&_h1]:mb-4
              [&_h2]:text-white [&_h2]:font-heading [&_h2]:text-xl [&_h2]:mt-6 [&_h2]:mb-3
              [&_h3]:text-[#00FF00] [&_h3]:text-lg [&_h3]:mt-4 [&_h3]:mb-2
              [&_p]:mb-4 [&_ul]:mb-4 [&_ol]:mb-4 [&_li]:mb-1
              [&_a]:text-[#00FF00] [&_a]:hover:underline
              [&_strong]:text-white"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
          />
        ) : (
          <p className="text-slate-500 italic">
            {lang === 'en' ? 'This page has not been configured yet.' : 'Cette page n\'a pas encore été configurée.'}
          </p>
        )}
      </div>
    </div>
  );
}
